import React, { Component } from 'react';
import DepartamentoListado from './Components/DepartamentoListado';

import './App.css';

class App extends Component {
  render() {
    let params = new URLSearchParams(window.location.search);
    if (!params.has('desarrollo')) {
      return <div>ERR25 - No hay desarrollo</div>;
    } else {
      const desarrollo = params.get('desarrollo');
      return <DepartamentoListado desarrollo={ desarrollo } />
    }
  } 
}

export default App;



// WEBPACK FOOTER //
// ./react_src/App.js